import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const notifications = [{
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'David Smith',
  initials: 'DS',
  time: '12 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Emily Chen',
  initials: 'EC',
  time: '18 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'Michael Brown',
  initials: 'MB',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Jessica Walsh',
  initials: 'JW',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" aria-live="polite" data-id="element-242" data-mp="ylr0jwvh4nhs">
      <AnimatePresence mode="wait" data-id="element-243" data-mp="3j8ubck8hwbx0">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-cream-card border border-gold-light rounded-xl p-3.5 shadow-[0_10px_30px_-12px_rgba(14,37,67,0.45)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-244" data-mp="3kr2g43tu64u0">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-warmgray hover:text-navy-deep transition-colors" aria-label="Close notification" data-id="element-245" data-mp="31ygoxwtvj2fr">
              <XIcon size={14} data-id="element-246" data-mp="2x1q6j2uljur6" />
            </button>
            <div className="flex items-center gap-3" data-id="element-247" data-mp="2j1p7lsxw6xec">
              <div className="relative shrink-0" data-id="element-248" data-mp="2j28p58jmrjru">
                <div className="w-11 h-11 rounded-full bg-navy-deep flex items-center justify-center text-gold-light font-bold text-sm" data-id="element-249" data-mp="2n3k6kqscoyoy">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-cream-card shadow" data-id="element-250" data-mp="1zg6ttwgj4p6q" />
              </div>
              <div className="flex-1 min-w-0 pr-4" data-id="element-251" data-mp="2nct1a1ogpfs5">
                <div className="flex items-center gap-1.5 text-[11px] text-warmgray mb-0.5" data-id="element-252" data-mp="2nbhvjwbghxye">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-253" data-mp="2icf3dcgkrm7u" />
                  <span className="truncate" data-id="element-254" data-mp="2s6ouyrxp0ghi">{current.location}</span>
                </div>
                <p className="text-navy-deep text-[13px] leading-snug" data-id="element-255" data-mp="361znvzsdmrj8">
                  <span className="font-bold" data-id="element-256" data-mp="316c09otjm6fu">{current.name}</span>{' '}
                  <span className="text-ink" data-id="element-257" data-mp="3l7x1wgwyhgzx">
                    purchased BJJ Instructor Ready
                  </span>
                </p>
                <div className="flex items-center gap-1.5 text-[10px] text-forest font-medium mt-1" data-id="element-258" data-mp="3p6w43trayzno">
                  <span className="w-1.5 h-1.5 rounded-full bg-forest animate-pulse" data-id="element-259" data-mp="3u079rrkdpae0" />
                  <ShoppingBagIcon size={10} data-id="element-260" data-mp="2smh9p30tzp0" />
                  <span data-id="element-261" data-mp="328j1bg4q180g">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}